export default {
    name: 'v5-icon-map-fill',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M512 959.47c-10.7 0-16.605-1.284-20.366-5.69-2.261-2.65-229.644-272.535-290.237-403.233-21.89-46.818-33.443-97.655-33.443-147.265 0-187.09 154.332-339.226 344.046-339.226s344.046 153.188 344.046 341.43c0 56.87-10.661 99.841-36.79 148.3-72.25 133.89-284.46 396.833-286.58 399.456-2.533 3.167-7.056 6.228-20.146 6.228H512zm0-687.067c-72.96 0-132.326 59.365-132.326 132.326S439.04 537.055 512 537.055s132.326-59.365 132.326-132.326S584.96 272.403 512 272.403z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
